import { balance, minor } from "./model";
import type { DeliveryCompany, EntryKind } from "./use-delivery-companies";
export const KIND_LABELS: Record<EntryKind,string> = {pay:"Pay delivery company",charge:"Charge delivery company",received:"Received from delivery company"};
export const ENTRY_ACTIONS: {kind:EntryKind;description:string;effect:string;color:string}[] = [
  {kind:"pay",description:"We paid them cash from the box",effect:"Box − · delivery expense",color:"var(--red)"},
  {kind:"charge",description:"We charge them. No cash moves",effect:"Box unchanged · they owe us more",color:"var(--mut)"},
  {kind:"received",description:"They gave us cash",effect:"Box + · they owe us less",color:"var(--green)"},
];
export function canChooseCompany(company:DeliveryCompany,kind:EntryKind,branchId:string) {
  return company.status==="active" || kind==="received"&&balance(company,branchId)>0;
}
export function entryErrors(input:{companyId:string;amount:string;reason:string;photoDataUrl:string;kind:EntryKind;cashBalance:string}) {
  const e:Record<string,string>={};
  if(!input.companyId)e.company="Choose a company.";
  if(!/^\d+(?:\.\d{1,2})?$/.test(input.amount)||minor(input.amount)<=0)e.amount="Enter an amount above 0.";
  else if(input.kind==="pay"&&minor(input.amount)>minor(input.cashBalance))e.amount="The box has only {0}.";
  if(!input.reason.trim())e.reason="Write a reason.";
  if(!input.photoDataUrl)e.photo="Add a photo.";
  return e;
}
